import { useParams } from 'react-router-dom';
import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Star } from "lucide-react";
import listinguser1 from '../assets/listinguser1.png';
import listinguser2 from '../assets/listinguser2.png';
import farmitem3 from '../assets/farmitem3.png';
import farmitem4 from '../assets/farmitem4.png';
import instock from '../assets/in-stock.png';
import farm from '../assets/farm.png';
import '../style/productdetail.css';
import shipping from '../assets/shipping.png';
import share from '../assets/share.png';
import Help from '../assets/Help.png';
import beefsteak from '../assets/beefsteak.webp';
import blackangus from '../assets/blackangus.webp';
import product1 from '../assets/product1.png';
import product2 from '../assets/product2.png';
import product3 from '../assets/product3.png';
import product4 from '../assets/product4.png';
import product5 from '../assets/product5.png';
import product6 from '../assets/product6.png';
import bestmatch from '../assets/bestmatch.png';
import { Link } from 'react-router-dom';

const ProductDetail = () => {
  const { id } = useParams();
  const productId = parseInt(id);

  // Vendor products data (IDs 101-202)
  const vendors = [
    {
      id: 1,
      name: "R&B Rhyne Farm",
      location: "Angier, North Carolina",
      image: listinguser1,
      products: [
        {
          id: 101,
          name: "Black Angus Ground",
          price: "$65.00/Unit",
          image: blackangus,
          galleryImages: [blackangus, product1, product2, product3]
        },
        {
          id: 102,
          name: "Beef Steak",
          price: "$70.00/Unit",
          image: beefsteak,
          galleryImages: [beefsteak, product4, product5, product6]
        },
      ],
    },
    {
      id: 2,
      name: "Acorn Acres Farmhouse",
      location: "Angier, North Carolina",
      image: listinguser2,
      products: [
        {
          id: 201,
          name: "Lamb Chops",
          price: "$80.00/Unit",
          image: farmitem3,
          galleryImages: [farmitem3, product1, product2]
        },
        {
          id: 202,
          name: "Pork Belly",
          price: "$75.00/Unit",
          image: farmitem4,
          galleryImages: [farmitem4, product3, product4]
        },
      ],
    },
  ];

  // Standalone products data (IDs 1-6)
  const standaloneProducts = [
    {
      id: 1,
      name: "Wireless Headphones",
      description: "Lorem bring together hundreds vendors under one roof giving your vast catalogs",
      price: 500,
      image: product1,
      galleryImages: [product1, product2, product3, product4]
    },
    {
      id: 2,
      name: "Smart Watch",
      description: "Lorem bring together hundreds vendors under one roof giving your vast catalogs",
      price: 586,
      image: product2,
      galleryImages: [product2, product3, product4, product5]
    },
    {
      id: 3,
      name: "Bluetooth Speaker",
      description: "Lorem bring together hundreds vendors under one roof giving your vast catalogs",
      price: 972,
      image: product3,
      galleryImages: [product3, product4, product5, product6]
    },
    {
      id: 4,
      name: "Multiple Vendors Meet Your Needs",
      description: "Lorem bring together hundreds vendors under one roof giving your vast catalogs",
      price: 500,
      image: product4,
      galleryImages: [product4, product5, product6, product1]
    },
    {
      id: 5,
      name: "Multiple Vendors Meet Your Needs",
      description: "Lorem bring together hundreds vendors under one roof giving your vast catalogs",
      price: 586,
      image: product5,
      galleryImages: [product5, product6, product1, product2]
    },
    {
      id: 6,
      name: "Multiple Vendors Meet Your Needs",
      description: "Lorem bring together hundreds vendors under one roof giving your vast catalogs",
      price: 972,
      image: product6,
      galleryImages: [product6, product1, product2, product3]
    },
  ];

  let product = null;
  let vendor = null;

  // First check in vendors' products
  for (const v of vendors) {
    const foundProduct = v.products.find(p => p.id === productId);
    if (foundProduct) {
      product = foundProduct;
      vendor = v;
      break;
    }
  }

  // If not found in vendors, check in standalone products
  if (!product) {
    product = standaloneProducts.find(p => p.id === productId);
    if (product) {
      // Create a dummy vendor for standalone products
      vendor = {
        name: "Verified Vendor",
        location: "United States",
        image: listinguser1
      };
    }
  }

  const [mainImage, setMainImage] = useState(product?.image || '');

  if (!product) {
    return (
      <Container className="py-5">
        <h2>Product not found</h2>
      </Container>
    );
  }

  return (
    <div>
      <section className="product-detail-section bg-white ">
        <Container>
          <Row>
            <Col md={6} className="image-gallery">
              <div className='productimagewithgallery'>
                <div className="main-image mb-3">
                  <img src={mainImage} className="img-fluid rounded" alt={product.name} />
                </div>

                <div className="imagegallerywrapper d-flex flex-column gap-2">
                  {product.galleryImages.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`Thumbnail ${index}`}
                      className="img-thumbnail"
                      style={{ width: '60px', height: '60px', cursor: 'pointer' }}
                      onClick={() => setMainImage(img)}
                    />
                  ))}
                </div>
              </div>

              <div className="faq-container mt-4">
                {["Description", "Other Options", "Shipping & Warranty"].map((title, idx) => (
                  <div className="faq-item" key={idx}>
                    <button className="faq-question">{title}</button>
                    <div className="faq-answer">
                      <p>Lorem journey begins with the Z 5...</p>
                    </div>
                  </div>
                ))}
              </div>
            </Col>

            <Col md={6}>
              <div className="vendor-info mb-3 d-flex align-items-center">
                <img
                  src={vendor.image}
                  alt={vendor.name}
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    marginRight: '10px'
                  }}
                />
                <div>
                  <h5 className="mb-0">{vendor.name}</h5>
                  <small className="text-muted">{vendor.location}</small>
                </div>
              </div>

              <h3 className="fw-semibold">{product.name}</h3>
              <h4 className="me-3 text-success">{product.price}</h4>

              <div className="d-flex align-items-center mb-3">
                <div className="text-warning d-flex align-items-center">
                  {[...Array(4)].map((_, i) => <Star key={i} size={16} fill="gold" />)}
                  <Star size={16} stroke="gold" />
                  <small className="ms-2">4.2 (1653)</small>
                </div>
              </div>

              <ul className="productsbullets list-unstyled mb-4">
                <li><img src={instock} alt="In stock"/>Currently In Stock</li>
                <li><img src={farm} alt="Farm"/>Lorem Details , Lorem Details</li>
              </ul>

              <div className="d-flex gap-3 mb-4">
                <Button className='addtocart' variant="success">Add to Cart</Button>
                <Button className='buyitfornow' variant="outline-dark">Buy It Now</Button>
              </div>

              <div className="mt-5">
                <ul className='gotanyquestion'>
                  <li><img src={Help} alt="Help"/>Got any questions? <a href='#'>Contact us</a></li>
                  <li><img src={shipping} alt="Shipping"/>Free Shipping over $150</li>
                  <li><img src={share} alt="Share"/><a href="#">Share</a></li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="products vreifiedvendors productsdetailsrecomanded">
        <Container>
          <Row>
            <Col md="12">
              <h2>Recommended Products</h2>
              <p className='mainpara'>Browse similar products you might like...</p>
            </Col>
          </Row>
          <Row>
            {standaloneProducts.filter(p => p.id !== productId).slice(0, 3).map((product) => (
              <Col md="4" key={product.id}>
                <div className='productmain'>
                  <Link to={`/product/${product.id}`} className="product-link">
                    <img src={product.image} alt={product.name}/>
                    <div className='bestmatch'><img src={bestmatch} alt="Best match"/></div>
                    <h4>${product.price}</h4>
                    <h5>{product.name}</h5>
                    <p>{product.description}</p>
                    <a href='#'>Buy Offers possibilities</a>
                  </Link>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default ProductDetail;